import { supabase } from "@/lib/supabase/client";

export type OpeningHourItem = {
    id: string;
    section: 'opening_hours' | 'childcare';
    day_label: string;
    time_range: string;
    sort_order: number;
    is_active: boolean;
    created_at?: string;
};

export async function fetchOpeningHours(includeInactive = false) {
    let query = supabase
        .from('opening_hours')
        .select('*')
        .order('sort_order', { ascending: true });

    if (!includeInactive) {
        query = query.eq('is_active', true);
    }

    const { data, error } = await query;

    if (error) {
        console.error('Error fetching opening hours:', error);
        return [];
    }
    return data as OpeningHourItem[];
}

export async function createOpeningHour(item: Omit<OpeningHourItem, 'id' | 'created_at'>) {
    const { data, error } = await supabase
        .from('opening_hours')
        .insert([item])
        .select()
        .single();
    
    if (error) throw error;
    return data;
}

export async function updateOpeningHour(id: string, updates: Partial<OpeningHourItem>) {
    const { data, error } = await supabase
        .from('opening_hours')
        .update(updates)
        .eq('id', id)
        .select()
        .single();

    if (error) throw error;
    return data;
}

export async function deleteOpeningHour(id: string) {
    const { error } = await supabase
        .from('opening_hours')
        .delete()
        .eq('id', id);

    if (error) throw error;
}
